import script from "./UploadMultiVoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadMultiVoice.vue?vue&type=script&setup=true&lang=ts"

import "./UploadMultiVoice.vue?vue&type=style&index=0&id=09a091c5&scoped=true&lang=scss"
script.__scopeId = "data-v-09a091c5"

export default script